import { WebglObject, getItemByField, FixedDimension } from "../../../../web-graphics";

export class CentralSignalsBoxPanel extends WebglObject {
  constructor(settings) {
    super(settings);
  }

  createBorders() {
    super.createBorders();
    this.updateSignalsPositions();
  }

  updateSignalsPositions() {
    this.settings.dataSourcesContainer.forEachChild(dataSourceContainer => {
      const dataSourceId = parseInt(dataSourceContainer.name, 10);
      const dataSourceSettings = getItemByField("id", dataSourceId, this.settings.dataSourcesSettings);
      const channelsContainer = dataSourceContainer.findItem("channels");
      if (channelsContainer !== undefined) {
        channelsContainer.forEachChild(channelContainer => {
          const channelId = parseInt(channelContainer.name, 10);
          const channelSettings = getItemByField("id", channelId, dataSourceSettings.channels);
          const channelY = channelSettings.y.calcValue(this.settings.clientSize.height);
          const channelHeight = channelSettings.height.calcValue(this.settings.clientSize.height);
          const configurationSettings = getItemByField("name", channelContainer.configuration, channelSettings.configurations);
          if (channelSettings.showIsolines) {
            const isolinesContainer = channelContainer.findItem("isolines");
            if (isolinesContainer !== undefined) {
              isolinesContainer.forEachChild(isolineItem => {
                const isolineId = parseInt(isolineItem.name, 10);
                const isolineSettings = getItemByField("id", isolineId, configurationSettings.isolines);
                const isolineObject = isolineItem.item;
                const isolineY = channelY + isolineSettings.y.calcValue(channelHeight);
                isolineObject.plotSize = {
                  width: this.settings.clientSize.width,
                  height: this.settings.clientSize.height
                };
                isolineObject.setParentSize(this.settings.clientSize.width, this.settings.clientSize.height);
                isolineObject.setLocation(new FixedDimension(0), new FixedDimension(isolineY));
                isolineObject.createBorders();
              });
            }
          }
          const signalsContainer = channelContainer.findItem("signals");
          if (signalsContainer !== undefined) {
            signalsContainer.forEachChild(signalItem => {
              const signalId = parseInt(signalItem.name, 10);
              const signalSettings = getItemByField("id", signalId, configurationSettings.signals);
              const isolineSettings = getItemByField("id", signalSettings.id_isoline, configurationSettings.isolines);
              const isolineY = channelY + isolineSettings.y.calcValue(channelHeight);
              const signalObject = signalItem.item;
              signalObject.plotLocation = {
                x: this.settings.absoluteLocation.x,
                y: this.settings.absoluteLocation.y
              };
              signalObject.plotSize = {
                width: this.settings.clientSize.width,
                height: this.settings.clientSize.height
              };
              signalObject.setParentSize(this.settings.clientSize.width, this.settings.clientSize.height);
              signalObject.setLocation(new FixedDimension(0), new FixedDimension(isolineY));
              signalObject.createBorders();
            });
          }
        });
      }
    });
  }

  draw(gl, program) {
    super.draw(gl, program);
    this.settings.dataSourcesContainer.recursiveExecute("draw", gl, program);
  }
}
